
<router-outlet></router-outlet>
<app-loader></app-loader>